import {SurveyJourneyStage} from "crqlar-react-common/dist/models/survey/surveyFeedbackTheme.model";

const SURVEY_JOURNEY_STAGE_LABEL_KEYS: Record<SurveyJourneyStage, string> = {
    [SurveyJourneyStage.ARRIVAL_CHECK_IN]: 'Arrival & check-in',
    [SurveyJourneyStage.ROOM_SLEEP]: 'Room & sleep',
    [SurveyJourneyStage.FOOD_DRINK]: 'Food & drink',
    [SurveyJourneyStage.SPA_WELLNESS]: 'Spa & wellness',
    [SurveyJourneyStage.SERVICE_STAFF]: 'Service & staff',
    [SurveyJourneyStage.VALUE_PRICE]: 'Value & price',
    [SurveyJourneyStage.GENERAL]: 'General',
};

export const SURVEY_JOURNEY_STAGES: SurveyJourneyStage[] = [
    SurveyJourneyStage.ARRIVAL_CHECK_IN,
    SurveyJourneyStage.ROOM_SLEEP,
    SurveyJourneyStage.FOOD_DRINK,
    SurveyJourneyStage.SPA_WELLNESS,
    SurveyJourneyStage.SERVICE_STAFF,
    SurveyJourneyStage.VALUE_PRICE,
    SurveyJourneyStage.GENERAL,
];

export const surveyJourneyStageLabelKey = (stage: SurveyJourneyStage | undefined): string => (
    (stage && SURVEY_JOURNEY_STAGE_LABEL_KEYS[stage]) || stage || SURVEY_JOURNEY_STAGE_LABEL_KEYS.GENERAL
);
